import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useResource from 'Hooks/useResource';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  RichTextAlertDescription,
} from 'Views/Page/Content/Modal/Layouts/JobBasicInformationStep/Layout/RichTextAlertDescription';
import { PXFormModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXFormModalWrapper';
import { FormSection } from 'Components/ComponentLibrary/Molecules/FormSection';
import ESPMatchCollectionForm from './ESPMatchCollectionForm';

const Layout = () => {
  const { resource: ctxResource } = useMetaLayoutContext();
  const { resource, setAttribute } = useResource(ctxResource);

  const handleAdd = (attrName) => () => {
    const coll = resource.attr(attrName).create({ addToCollection: true });
    setAttribute(attrName, coll);
  };

  const handleRemove = () => {
    const coll = resource.attr('espMatches');
    const lastIndex = coll.resources().length() - 1;
    coll.resources().removeItemByIndex(lastIndex);
    setAttribute('espMatches', coll);
  };

  return (
    <PXFormModalWrapper>
      <MetaControlField
        attr="espMatchesDescription"
        CustomProps={{
          Component: RichTextAlertDescription,
        }}
      />
      <ESPMatchCollectionForm
        resource={resource}
        attrName={'espMatches'}
        handleAdd={handleAdd}
        handleRemove={handleRemove}
      />
      <FormSection title={'Account Information'}>
        <MetaControlField attr="employeeContributionRetirementAccount" flex={1} />
        <MetaControlField attr="employerContributionRetirementAccount" flex={1} />
      </FormSection>
    </PXFormModalWrapper>
  );
};

export default Layout;
